import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from 'tradera-lang';

const Title = props => {
    const { youtube, instagramAlias } = props;
    const { t } = useTranslator();
    return (
        <h4 className="mx-4 text-styled text-center">
            <strong>
                {youtube && instagramAlias
                    ? `${t(
                          'socialMedia_title'
                      )} YouTube & Instagram (@${instagramAlias})`
                    : youtube
                    ? `${t('socialMedia_title')} YouTube`
                    : `${t(
                          'socialMedia_title'
                      )} Instagram (@${instagramAlias})`}
            </strong>
        </h4>
    );
};

Title.propTypes = {
    youtube: PropTypes.bool,
    instagramAlias: PropTypes.string
};

export default React.memo(Title);
